import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ProductsList from '../../components/products/ProductsList';
import ProductCardList from '../../components/common/ProductCardList';
import { CardListHeader, CardListHeaderTitle } from '../../components/common/ProductCardList.styles';
import { PageWrapper, PageContainer } from '../../components/common/PageWrapper.styles';
import { productsPageClass, TabBar, Tab, SplitLayout, SplitPanel, NarrowOnly, WideOnly } from './ProductsPage.styles';
import { getProductHistory } from '../../utils/productHistory';
import queryParamsUtils from '../../utils/queryParamsUtils';
import { useAuthStore } from '../../context/AuthContext';
import { ProductListItem } from '../../types/ProductTypes';

type ProductsTab = 'search' | 'last-visited';

const ProductsPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState<ProductsTab>('search');
    const navigate = useNavigate();
    const { setQueryParamProductId } = queryParamsUtils();
    const { canEdit, canEditChemGuard } = useAuthStore();
    const hasWriterRole = canEdit || canEditChemGuard;

    const handleProductClick = (product: ProductListItem) => {
        navigate('/product');
        setQueryParamProductId(product.id.toString());
    };

    return (
        <PageWrapper>
            <PageContainer className={productsPageClass}>
                {/* Wide screens: side-by-side layout */}
                <WideOnly>
                    <SplitLayout>
                        <SplitPanel>
                            <ProductCardList
                                items={hasWriterRole ? getProductHistory() : getProductHistory().filter((p) => !!p.tradeName)}
                                onProductClick={handleProductClick}
                                emptyMessage="No recently visited products."
                                header={
                                    <CardListHeader>
                                        <CardListHeaderTitle>Last Visited</CardListHeaderTitle>
                                    </CardListHeader>
                                }
                            />
                        </SplitPanel>
                        <SplitPanel>
                            <ProductsList hideHeader />
                        </SplitPanel>
                    </SplitLayout>
                </WideOnly>

                {/* Narrow screens: tabbed layout */}
                <NarrowOnly>
                    <TabBar>
                        <Tab $active={activeTab === 'search'} onClick={() => setActiveTab('search')}>
                            Search
                        </Tab>
                        <Tab $active={activeTab === 'last-visited'} onClick={() => setActiveTab('last-visited')}>
                            Last Visited
                        </Tab>
                    </TabBar>
                    {activeTab === 'search' && <ProductsList />}
                    {activeTab === 'last-visited' && <ProductsList showPreviouslyVisited hideSearch />}
                </NarrowOnly>
            </PageContainer>
        </PageWrapper>
    );
};

export default ProductsPage;
